import React from 'react';

import { Typography, Button } from '../../../../components';
const { Paragraph, Title } = Typography;

export const ReviewContents = ({ resetForm, addToInventory, isUploading }) => {
    return (
        <div className="review-contents">
            <Title level={2}>Review Contents Below</Title>
            <Paragraph>
                Review the imported data from your RV Tools CSV before adding it to your inventory. Make sure the
                columns and values look correct before proceeding.
            </Paragraph>
            <div className="button-group">
                <Button type="default" size="medium" disabled={isUploading} onClick={resetForm}>
                    Restart
                </Button>
                <Button type="primary" size="medium" onClick={addToInventory} loading={isUploading}>
                    {isUploading ? 'Adding to Inventory...' : 'Add to Inventory'}
                </Button>
            </div>
        </div>
    );
};
